import { useQuery } from '@tanstack/react-query'
import { getEmailEngagement } from '@/api/analytics'

export function useEmailEngagement() {
  return useQuery({ queryKey: ['analytics', 'email'], queryFn: getEmailEngagement })
}
